import { Image, Text, View } from '@react-pdf/renderer';

import { CompTypeBadge } from '../components/CompTypeBadge.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles, gridStyles } from '../styles.ts';
import { SalesComparablePhotosDataPageProps } from '../types.ts';

export const SalesComparablePhotosPage = ({
  subjectAddress,
  salesComparablePhotosData,
  compSequence,
}: SalesComparablePhotosDataPageProps) => (
  <>
    {salesComparablePhotosData.map((comp) => (
      <Tkv2PDFPage
        key={`pageIndex_${comp.address}`}
        title="Appendix: Sales Comparable Photos"
        address={subjectAddress}
      >
        <View>
          <View style={{ ...gridStyles.row, justifyContent: 'space-between' }}>
            <View style={[gridStyles.compactRow, { alignItems: 'center', gap: 4 }]}>
              <Text style={fontStyles.bodyBold}>
                Comparable {compSequence.indexOf(comp.id) + 1}:&nbsp;
              </Text>
              <Text style={fontStyles.body}>{comp.address}</Text>
              {comp.compType && <CompTypeBadge compType={comp.compType} />}
            </View>
            <View style={gridStyles.compactRow}>
              <Text style={fontStyles.bodyBold}>{comp.transactionText}: </Text>
              <Text style={fontStyles.body}>{comp.price?.toString(true)}</Text>
            </View>
          </View>
          <View style={gridStyles.photoGrid}>
            {comp.photos.map((photoBlob, index) => (
              <Image
                style={{ height: 116, width: 175 }}
                source={photoBlob}
                // eslint-disable-next-line react/no-array-index-key
                key={`photo_${index}_${comp.address}`}
              />
            ))}
          </View>
        </View>
      </Tkv2PDFPage>
    ))}
  </>
);
